import React from 'react';
import { useTranslation } from 'react-i18next';
import { DropdownContainer, Title, InputsWrapper } from './styles';
import SelectDropdown from '../SelectDropdown';
import { getDevice } from '@panel/commons/helpers';

const SelectSection = ({
  adaptedBranches,
  adaptedUsersOptions,
  hideSelectBranches,
  isUsersEmpty,
  postingId,
  handleFieldChange,
  register,
  watch
}) => {
  const device = getDevice();
  const { t } = useTranslation();
  return (
    <DropdownContainer>
      <Title data-publi='publishStep-responsable-title'>{t('professionalPubli.publish.selectSection.title')}</Title>
      <InputsWrapper device={device}>
        {!hideSelectBranches && (
          <SelectDropdown
            label={t('professionalPubli.publish.selectSection.branches.label')}
            options={adaptedBranches}
            isBranch
            postingId={postingId}
            handleFieldChange={handleFieldChange}
            watch={watch}
            {...register('branch')}
            device={device}
            dataPubli='publicador-publishStep-selectSection-branches'
          />
        )}
        {!isUsersEmpty && (
          <SelectDropdown
            label={t('professionalPubli.publish.selectSection.responsible.label')}
            options={adaptedUsersOptions}
            postingId={postingId}
            handleFieldChange={handleFieldChange}
            watch={watch}
            {...register('responsible')}
            device={device}
            dataPubli='publicador-publishStep-selectSection-responsible'
          />
        )}
      </InputsWrapper>
    </DropdownContainer>
  );
};

export default SelectSection;
